<template>
    <div class="row">
        <div class="col-12">
            <div :class="'text-center' + (datos_online.qr_codes.length > 0 ? ' mb-3' : '')">
                <p class="h4" v-if="datos_online.puede_descargar_entradas">
                    {{ $t(datos_online.qr_codes.length > 0 ? 
                        (!reserva_instalaciones ? "gracias.descargar_entradas" : "gracias.descargar_reservas") : 
                        "gracias.descargar_productos")
                    }}
                </p>
                <p class="h4" v-else>
                    ¡Compra confirmada!
                </p>
                <div class="d-flex justify-content-center">
                    <p class="mr-2 mt-1">
                        {{ $t("gracias.n_pedido") }}:
                    </p>
                    <h4 id="n-pedido">
                        {{ tpv_order }}
                    </h4>
                </div>
            </div>

            <div class="text-center buttons mb-3" v-if="datos_online.qr_codes.length">
                <a 
                    :href="datos_online.url_descarga"
                    class="button large-button effect-button mr-lg-2 mb-2"
                    target="_blank"
                    v-if="datos_online.puede_descargar_entradas"
                >
                    <span style="text-transform: uppercase">
                        {{ !reserva_instalaciones ? $t("gracias.descargar_pdf_completo") : $t('gracias.descargar_pdf_completo_reservas') }}
                    </span>
                </a>
                <router-link 
                    tag="a" 
                    :to="{ name: 'front.home' }"
                    class="button large-button effect-button mr-lg-2 mb-2"
                >
                    <span>{{ $t("gracias.volver") }}</span>
                </router-link>
            </div>
            <div class="h4 mb-3" v-if="datos_compradores.length">
                Fecha: {{ sesion_fecha }}
            </div>
            <div class="h5 mb-3" v-if="datos_compradores[0]?.visibilidad_reducida">
                <span v-if="datos_compradores.length > 1">{{ $t("gracias.entradas_vision_reducida") }}</span>
                <span v-else>{{ $t("gracias.entrada_vision_reducida") }}</span>
            </div>
            <div>
                <TarjetaEntrada
                    v-for="(datos_comprador, i) in datos_compradores"
                    v-bind:key="i"
                    :entrada="datos_comprador"
                    :index="i"
                    :reserva_instalaciones="reserva_instalaciones"
                    :puede_descargar_entradas="datos_online.puede_descargar_entradas"
                />
                <template v-if="productos.length > 0">
                    <b-row class="pt-3 justify-content-between">
                        <b-col cols="2" class>
                            <div class="h4 my-3" >{{ $t("gracias.productos") }}</div>
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <a 
                                :href="getUrlPdfProducts(productos[0].qr_code)"
                                class="button large-button effect-button mr-lg-2 mb-2"
                                target="_blank"
                                v-if="datos_online.puede_descargar_entradas"
                            >
                                <span style="text-transform: uppercase">
                                    DESCARGAR PRODUCTOS
                                </span>
                            </a>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <TarjetaProducto
                                v-for="(producto, i) in productos"
                                v-bind:key="i"
                                :producto="producto"
                                :index="i"
                            />
                        </b-col>
                    </b-row>
                </template>
            </div>
            <div class="mt-3" v-if="datos_online.puede_descargar_entradas">
                <template v-if="!es_dia_abonado">
                    <p>
                        <b>
                            {{ $t(
                                datos_online.qr_codes.length > 0 
                                    ? (!reserva_instalaciones ? "gracias.duda_incidencia" : "gracias.duda_incidencia_reservas") 
                                    : "gracias.duda_incidencia_productos", 
                                { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }
                            ) }}
                        </b>
                    </p>
                </template>
                <template v-else>
                    <h1>
                        {{ $t("gracias.abono_activado") }}
                    </h1>
                    <b>{{ $t("gracias.recuerda") }}</b>
                    <ul>
                        <li>
                            {{ $t("gracias.una_entrada", {abonado: teatro.texto_abonado}) }}
                        </li>
                        <li>
                            {{ $t("gracias.validez_abono", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.acceso_nominativo", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.abono_personal", {abono: teatro.texto_abono}) }}
                        </li>
                        <li>
                            {{ $t("gracias.acceso") }}
                        </li>
                    </ul>
                    <p>
                        {{ $t("gracias.cuestion", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                    </p>
                </template>
            </div>

            <div class="mt-3" v-if="! datos_online.puede_descargar_entradas">
                <p>Gracias por confiar en <b>Compralaentrada</b>. Tu transacción ha sido procesada con éxito.</p><b></b>
                <p><b>¿Qué sucede ahora?</b></p>
                <ul>
                    <li>Te hemos enviado un justificante de compra a tu correo electrónico con todos los detalles de tu compra.</li>
                    <li><b>Tus entradas serán enviadas 72 horas antes del evento</b>, por motivos de seguridad. No te preocupes, ¡todo está en orden!</li>
                    <li>Si seleccionaste la opción de recibir las entradas por <b>WhatsApp</b>, también las recibirás en ese medio dentro del mismo plazo.</li>
                </ul>
                <p>
                    Recuerda revisar tu bandeja de entrada y, en caso de que no las encuentres, no olvides verificar la carpeta de spam o correo no deseado.
                </p>
                <p>
                    <b>Si tienes alguna pregunta o necesitas ayuda</b>, no dudes en ponerte en contacto con nosotros. ¡Estamos aquí para ayudarte!
                </p>
                <p>
                    ¡Nos vemos en el evento!
                </p>
                <p>
                    El equipo de <b>Compralaentrada</b>
                </p>
            </div>
        </div>

        <SendFacebookPetition 
            v-if="pixel_id" 
            :evento_id="String(evento_id)"
            event_name="Purchase"
            :evento_name="evento_name"
            :nombre="datos_peticion.nombre"
            :apellidos="datos_peticion.apellidos" 
            :email="datos_peticion.email"
            :quantity="datos_compradores.length" 
            :total="total" 
            :url_evento="url_evento"
            :user_order="tpv_order"
            :user_id="user_id"
            :cp="datos_peticion.cp"
            :telefono="datos_peticion.telefono" 
        />
    </div>
</template>

<script>
import SendFacebookPetition from "@/components/common/SendFacebookPetition";
import TarjetaEntrada from "./components/TarjetaEntrada.vue";
import TarjetaProducto from "./components/TarjetaProducto.vue";

export default {
    props: {
        tpv_order: {
            required: true,
            type: String
        },
        datos_online: {
            required: true,
            type: Object
        },
        datos_compradores: {
            type: Array,
            required: true
        },
        productos: {
            type: Array
        },
        es_dia_abonado: {
            required: true,
            type: Boolean
        },
        evento_id: {
            required: true,
            type: Number
        },
        evento_name: {
            required: true,
            type: String
        },
        total: {
            required: true,
            type: Number
        },
        url_evento: {
            required: true,
            type: String
        },
        user_id: {
            required: true,
            type: Number
        },
        datos_peticion: {
            required: true,
            type: Object
        },
        sesion_fecha: {
            required: true,
            type: String
        },
        reserva_instalaciones: {
            type: [Boolean, Number],
            default: false
        }
    },
    data() {
        return {
            pixel_id: process.env.VUE_APP_PIXEL_ID,
            api_base: process.env.VUE_APP_API_BASE,
        }
    },
    methods: {
        getUrlPdfProducts(qr_code) {
            return this.api_base + '/f/partidos/productos/pdf?tid=' + this.configuracion.hash_teatro + '&qr_code=' + qr_code;
        }
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        teatro(){
            return this.$store.getters.getTeatro
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    components: {
        SendFacebookPetition, TarjetaEntrada, TarjetaProducto
    }
}
</script>